import { createShader, colorUniform } from "./ShaderBase.js";

export const staticShader = createShader({
  customizable: [
    { uniform: "uColorLight", label: "Light", default: "#ffffff" },
    { uniform: "uColorDark", label: "Dark", default: "#000000" },
  ],

  uniforms: {
    uPixelSize: { value: 8.0 },
    uScale: { value: 1.0 },
    uSpeed: { value: 15.0 },
    uColorLight: colorUniform("#ffffff"),
    uColorDark: colorUniform("#000000"),
    uContrast: { value: 0.9 },
  },

  fragmentUniforms: `
    uniform vec3 uColorLight;
    uniform vec3 uColorDark;
    uniform float uContrast;
  `,

  fragmentBody: `
    // Fast-changing noise for TV static effect
    float stepTime = floor(uTime * uSpeed * 10.0);

    // Primary static noise
    vec3 staticPos = pixelatedPos * 100.0 + vec3(stepTime * 0.73, stepTime * 0.91, stepTime);
    float noise1 = snoise(staticPos);

    // Secondary noise layer for variation
    vec3 staticPos2 = pixelatedPos * 50.0 + vec3(stepTime * 1.3, stepTime * 0.7, stepTime * 0.5);
    float noise2 = snoise(staticPos2);

    // Combine noises
    float staticNoise = (noise1 + noise2 * 0.5) / 1.5;
    staticNoise = (staticNoise + 1.0) * 0.5;

    // Apply contrast
    staticNoise = (staticNoise - 0.5) * uContrast + 0.5;
    staticNoise = clamp(staticNoise, 0.0, 1.0);

    // Mix between dark and light
    vec3 color = mix(uColorDark, uColorLight, staticNoise);

    // Occasional horizontal interference lines
    float lineNoise = snoise(vec3(0.0, pixelatedPos.y * 0.5, stepTime * 0.1));
    float interference = step(0.95, (lineNoise + 1.0) * 0.5);
    color = mix(color, uColorLight, interference * 0.3);

    // Subtle vertical rolling band
    float roll = sin(pixelatedPos.y * 0.1 + uTime * 2.0) * 0.5 + 0.5;
    roll = smoothstep(0.4, 0.6, roll);
    color *= 0.95 + roll * 0.1;

    gl_FragColor = vec4(color, 1.0);
  `,
});
